<app-layer-config-collapsible-category description="Warnings" storageKey="vzo-warnings">
  <app-layer-control-item
    description="Construction Sites"
    [isLayerVisibile]="isCSLayerVisible"
    [layerId]="Layers.ConstructionSites.name"
    icon="construction"
    (visibilityToggled)="toggleLayerVisbility($event)"
    *hasPermissionAny="Layers.ConstructionSites.permissions"
  ></app-layer-control-item>
</app-layer-config-collapsible-category>
